module.exports = {
  sanity: {
    projectId:
      process.env.GATSBY_SANITY_PROJECT_ID || "vbctn5oa",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};
